import { UAContext } from '@quentin-sommer/react-useragent';
import cn from 'classnames';
import React, { useContext } from 'react';
import Typography from '~components/typography';
import { getPropertyImageUrl } from '~utils/js-helper';
import styles from './property-card.module.scss';
interface IPropertyCardProps {
  propertyId: string | undefined | null;
  name: string;
  cityName: string | undefined | null;
  imageName: string | null;
  handleClick?: (id: string) => void;
}

const PropertyCard: React.FC<IPropertyCardProps & React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  propertyId,
  name,
  cityName,
  imageName,
  handleClick,
}) => {
  const uaResults = useContext(UAContext).uaResults as UAResults;
  const isMobile = uaResults.mobile;

  return (
    <div
      className={cn(styles.root, className)}
      onClick={() => {
        if (handleClick && propertyId) handleClick(propertyId);
      }}
    >
      <img className={styles.img} src={getPropertyImageUrl(imageName)} alt="" />
      <Typography
        component="div"
        className="residence-property-card-name"
        variant={isMobile ? 'body3' : 'h7'}
      >
        {`${name}, ${cityName}`}
      </Typography>
    </div>
  );
};

export default PropertyCard;
